import { render } from "./InitView.vue.ts?vue&type=template&id=5bec4253&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InitView.vue?vue&type=template&id=5bec4253&ts=true"
import script from "./InitView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InitView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InitView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InitView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/credit-line/views/InitView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bec4253"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bec4253', __exports__)) {
    api.reload('5bec4253', __exports__)
  }
  
  module.hot.accept("./InitView.vue.ts?vue&type=template&id=5bec4253&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InitView.vue?vue&type=template&id=5bec4253&ts=true", () => {
    api.rerender('5bec4253', render)
  })

}


export default __exports__